export enum interviewsTypes {
  FETCH_INTERVIEWS_REQUEST = "FETCH_INTERVIEWS_REQUEST",
  FETCH_INTERVIEWS_SUCCESS = "FETCH_INTERVIEWS_SUCCESS",
  FETCH_INTERVIEWS_FAILURE = "FETCH_INTERVIEWS_FAILURE",
}